import cx from 'classnames';
import { makeStyles } from 'design-system';
import Markdown from '@scale/frontend-lib/markdown';
import { RichTextInstructionJson } from '@scale/shared/projectInstruction/types';
import { useProjectInstructionContext } from '../projectInstructionContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RichText = ({ contentData }: { contentData: RichTextInstructionJson }) => {
  const classes = useStyles();
  const { description, title } = contentData;
  const { isMobileView } = useProjectInstructionContext();

  return (
    <div className={cx(classes.container, { [classes.mobileView]: isMobileView })}>
      {!isMobileView && (
        <div className={classes.titleContainer}>
          <h3
            dangerouslySetInnerHTML={{
              __html: Markdown.render(title.replace(/\n/g, '') || ''),
            }}
          ></h3>
          {contentData.hiddenFromCustomer && (
            <FontAwesomeIcon className={classes.hideIcon} icon="eye-slash" />
          )}
        </div>
      )}
      <div
        className={classes.content}
        dangerouslySetInnerHTML={{
          __html: Markdown.render(description?.replace(/\n/g, '') || ''),
        }}
      />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    '& iframe': {
      width: '100%',
      height: '100vh',
    },
    '& div': {
      overflowX: 'scroll',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#D1D5DB',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
    },
  },
  mobileView: {
    padding: '10px 20px',
  },
  content: {
    '& p': {
      lineHeight: 1.6,
    },
    '&  strong': {
      fontWeight: 700,
    },
    '& ul': {
      paddingLeft: 20,
      listStyleType: 'disc',
    },
    '& ol': {
      paddingLeft: 20,
      listStyleType: 'decimal',
    },
  },
  hideIcon: {
    color: theme.colors.gray50,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export default RichText;
